/**
 * RubyLingo — `PetAvatar`: con thú cưng bé CHỌN, bộ đồ đang mặc và "sân nhà" quanh nó
 * (M6, T065–T066 · T04).
 *
 * ⭐ QUYẾT ĐỊNH C3 — "ĐEO NGƯỜI" (chủ dự án chốt):
 *   Phụ kiện gắn lên ĐÚNG CHỖ trên người con vật (mũ lên đầu, khăn ở cổ, giày dưới chân…).
 *   ⚠️ T04 CHỈ CÒN VẾ "ĐEO NGƯỜI". Vế "BÀY CẢNH" (trang trí xếp hai hàng trời/đất) đã được
 *      CHUYỂN sang khối "Góc phòng của bé" ở `PetHousePage` — nơi bé KÉO THẢ chúng thành vị trí
 *      tự do và vị trí được lưu lên server. `PetAvatar` không còn nhận/vẽ đồ trang trí; nó chỉ
 *      giữ HAI DẢI MÀU `bg-pet-sky`/`bg-pet-ground` làm đường chân trời cho con vật đứng.
 *
 * ⭐⭐ T04 — VÌ SAO VẼ LẠI, VÀ VÌ SAO LÀ BA DẢI (điểm #2 chủ dự án báo):
 *   *"các icon đeo vô con pet cũng khá là thô, lung tung chả đẹp tý nào."*
 *
 *   Bản cũ đặt phụ kiện theo toạ độ của một khung 150×150 TRẮNG TRƠN, cỡ tính bằng **px cứng**
 *   (26–34px). Hai hệ quả:
 *     • Không có gì để mắt bám vào. Một chiếc mũ "lơ lửng" giữa nền trắng đọc ra là một emoji bị
 *       rơi, không phải một chiếc mũ đang đội — vì không có ĐƯỜNG CHÂN TRỜI nào để so.
 *     • Cỡ px cứng không ăn theo cỡ con vật. Con non 84px đội một chiếc mũ 34px (40% thân), con
 *       siêu cấp 124px cũng đội chiếc mũ 34px (27%) ⇒ mũ "tụt" dần khi con lớn lên.
 *
 *   Nay: (a) hai dải `bg-pet-sky` / `bg-pet-ground` cho một đường chân trời để đọc vị trí — mũ
 *   nằm trên trời, giày nằm trên cỏ; (b) cỡ phụ kiện quy theo `em` của ô vuông 200×200
 *   (mà `font-size` của nó ĐỔI THEO BẬC), nên phụ kiện phóng to cùng con vật.
 *
 * ⚠️⚠️ NEO PHỤ KIỆN TÍNH THEO **HỘP `1em` CỦA CON VẬT**, KHÔNG theo khung 200×200 — ĐỌC KỸ.
 *
 *   Bản đầu tiên neo phụ kiện theo `%` của KHUNG 200×200. Sai, và sai theo HAI đường:
 *     ① Con vật là một `<span>` INLINE trong `<div>` thường ⇒ nó trôi về GÓC TRÊN-TRÁI. Đo trên
 *        trình duyệt thật: tâm con vật ở **28,8% / 31,3%** thay vì 50% / 50%. Mọi phụ kiện canh
 *        giữa KHUNG, không canh giữa CON VẬT ⇒ mũ lơ lửng cạnh tai, kính nằm ngang MÁ chứ không
 *        trên mắt, khăn rơi dưới cằm. Đã sửa bằng `flex items-center justify-center`.
 *     ② Kể cả sau khi căn giữa, `%`-của-khung vẫn sai khi con vật LỚN LÊN: `font-size` đổi
 *        (84 → 104 → 124px) nên con vật chiếm 42% → 52% → 62% chiều cao khung, trong khi các con
 *        số `%` đứng yên. Mũ đúng ở bậc `baby` sẽ tụt xuống ngang mắt ở bậc `super`.
 *
 *   Nay con vật sống trong một HỘP `1em × 1em` (chính là ô chữ của nó), và MỌI phụ kiện neo theo
 *   hộp đó. Neo bằng `%`-của-hộp-`1em` khiến **vị trí cùng lớn lên với con vật** — không cần một
 *   bảng tra nào theo bậc. Còn SỐ của `%` ấy là của TỪNG ẢNH (`petAnchors.ts`), không dùng chung.
 *
 * ⚠️ Khung 200×200 vẫn CỐ ĐỊNH, và vẫn cần: nó cho con vật một khoảng thở đủ rộng và giữ cho
 *   `1em` ổn định ở mọi bề rộng màn hình.
 *
 * ⚠️ MỌI VỊ TRÍ ĐẾN TỪ DỮ LIỆU (`shop-items.json` → `slot`), KHÔNG TỪ MỘT BẢNG TRA TRONG TỆP NÀY.
 *   Còn "mũ thuộc vị trí nào" là câu hỏi DỮ LIỆU, và nó nằm trong JSON, nơi `shopItemsFileSchema`
 *   từ chối một phụ kiện thiếu `slot`. Nhờ vậy thêm một chiếc mũ mới = sửa JSON, không sửa tệp này.
 *   ⚠️ Ba trục vẫn nằm trong tệp này vì chúng là câu hỏi THỊ GIÁC, không phải danh mục:
 *      `ACCESSORY_Z` (tầng chồng), thứ tự hai lượt vẽ quanh con vật, và cách canh hộp vào neo.
 *
 * ⚠️ COMPONENT "CÂM" — như `ShopItemCard`: nó không đọc store, không gọi mạng. Ba lý do:
 *     • Kiểm thử được mọi tổ hợp đồ mà không phải dựng `rewardStore` + mock mạng.
 *     • Không có đường nào để phần vẽ tự ý mua hay mặc đồ.
 *     • `PetAvatar` sẽ còn được dùng ở màn kết quả và màn Bộ sưu tập sau này — nơi không có
 *       `shopStore`.
 *
 * ⚠️ KHÔNG hiển thị mức ❤️ Ở ĐÂY: `HeartMeter` (thanh trên) là chủ duy nhất của "con vật đang vui
 *    thế nào". Vẽ lại ở đây là hai nguồn cho cùng một sự thật, và chúng sẽ lệch nhau đúng vào lúc
 *    bé vừa cho ăn.
 *
 * ⭐ T066 — GIAI ĐOẠN TIẾN HOÁ: component này **không tự suy** giai đoạn từ số từ (nó không có số
 *    từ, và không nên có). Server đếm từ rồi trả về một ID (`pet.evolutionStage`); ở đây chỉ tra
 *    ID đó ra `{ name_vi, icon }`. Client tự đếm từ là mở đường cho hai bên nói hai giai đoạn
 *    khác nhau.
 *
 * ⭐ T04 — CON NÀO: cùng khuôn mẫu, và cùng lý do. `petType` do SERVER phân giải (`readPet` biến
 *    `NULL`/id lạ thành `DEFAULT_PET_ID`), nên ở đây luôn có một con hợp lệ. Component KHÔNG nhận
 *    `petChosen` — "bé đã chọn chưa" là câu hỏi của MÀN NHÀ (`PetHousePage` dùng nó để mời bé
 *    chọn), không phải của phần vẽ. Một prop mà component không bao giờ đọc là một lời nói dối
 *    trong bản hợp đồng của nó.
 *
 * ⚠️⚠️ TÊN CON VẬT LẤY TỪ `petNameVi(petType)`, **KHÔNG** nhận qua prop.
 *   Bản cũ nhận `petName` từ người gọi, và người gọi truyền `t('pet.name')` = `"Momo"` — hằng số.
 *   Khi bé chọn "Mèo Miu" thì nhãn đọc lên vẫn nói "Momo đang dùng: …", vì không ai bắt được sự
 *   lệch đó. Suy từ `petType` ở đây khiến tên con vật và hình con vật **không thể** nói khác nhau.
 *
 * ⚠️ KHÔNG dùng `style={{ transform: … }}` để xê dịch các lớp: Tailwind đặt vị trí bằng chính
 *    thuộc tính `transform`, nên một `transform` inline sẽ ĐÈ SẠCH lớp `-translate-x-1/2` và mọi
 *    thứ lệch đi trong im lặng. Đúng cái bẫy đã trả giá ở T056. Nhiều món cùng một vị trí thì
 *    chúng tự xếp cạnh nhau bằng `flex` — không cần phép tính nào.
 */

import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { stageDefinition } from '@shared/content/levels.js';
import { petEmojiFor, petNameVi } from '@shared/content/pets.js';
import { accessorySlotOf } from '@shared/content/shop.js';
import { ACCESSORY_SLOTS } from '@shared/pet-slots.js';
import type { AccessorySlot, EvolutionStage, PetType, ShopItem } from '@shared/types/reward.js';

import {
  accessoryLayoutFor,
  NO_ACCESSORY_OFFSET,
} from '../../lib/accessoryFit.js';
import type { AccessoryOffset } from '../../lib/accessoryFit.js';
import { cn } from '../../lib/cn.js';
import { petArtworkUrl } from '../../lib/petArtwork.js';
import { feetSplitFor, petAnchorFor } from '../../lib/petAnchors.js';
import type { PetAnchor, PetFeetAnchor } from '../../lib/petAnchors.js';
import { ShopArtwork } from '../../lib/shopArtwork.js';

/**
 * Momo "mặc định" — dùng làm hình ĐẠI DIỆN cho trạng thái CHƯA BIẾT gì (đang nạp).
 *
 * ⚠️ KHÔNG còn là hình của linh vật khi đã có dữ liệu: `PetAvatar` vẽ theo `petType` (con bé chọn)
 *    × `evolutionStage` do server trả — xem `petEmojiFor`. Hằng này chỉ còn cho `EmptyState` lúc
 *    chưa nạp xong, khi CHƯA biết bé đang có con nào.
 *
 * Xuất ra ngoài để màn hình chỉ có MỘT chỗ biết mặt Momo: hai chỗ tự khai hai emoji là hai chỗ
 * để lệch nhau.
 */
export const MOMO_ICON = '🐵';

/**
 * Cỡ con vật theo bậc tiến hoá — đặt `font-size` lên chính ô vuông 200×200.
 *
 * ⭐ HAI VIỆC TRONG MỘT DÒNG: `font-size` này vừa là cỡ của ảnh con vật (nó cao `1em`), vừa là
 *   ĐƠN VỊ GỐC cho mọi thứ quanh nó: hộp `1em × 1em` (hệ toạ độ của neo), bóng dưới chân, tia ✨
 *   của bậc Siêu cấp. Neo trong `petAnchors.ts` là `%`-của-hộp-`1em`, nên vị trí VÀ kích cỡ phụ
 *   kiện cùng lớn lên với con vật mà không cần một bảng tra nào theo bậc.
 */
const STAGE_TEXT_SIZE: Record<EvolutionStage, string> = {
  baby: 'text-[84px]',
  adult: 'text-[104px]',
  super: 'text-[124px]',
};

/**
 * ⚠️ KHUNG `1em` LÀ HỆ TOẠ ĐỘ DUY NHẤT; CÒN "ĐẦU/CỔ/MẮT NẰM Ở ĐÂU **TRONG** KHUNG ĐÓ" LÀ DỮ LIỆU
 *    ĐO ĐƯỢC, nằm trong `src/lib/petAnchors.ts` — KHÔNG phải một bảng hằng số trong tệp này.
 *
 *   Bản trước giữ ở đây hai bảng dùng chung cho CẢ 18 ảnh (`ACCESSORY_ANCHOR` +
 *   `ACCESSORY_TEXT_SIZE`), kèm một chú thích SAI số liệu ảnh (ghi 1024×1024). Số đo thật của 18
 *   ảnh `public/assets/pets/*.webp`: **512×512**, mực (pixel không trong suốt) rộng **43,9%–66,8%**,
 *   cao **94,1%–98,8%** — KHÔNG đồng nhất. Cụ thể: tâm thân `cx` 0,4365–0,5566 (trên hộp 84px là
 *   lệch ±5px mỗi bên) và đường MẮT ở 9,1%–27,0% chiều cao hộp. Một con số `top-[-45%]` cho kính
 *   không thể đúng cho mọi con ⇒ kính nằm ngang MÁ hoặc trên TRÁN (lệch tới 44px ≈ 52% hộp) —
 *   đúng lời chủ dự án: *"mua cái mắt kính, đeo vào là sát vào mặt"*. Nay mỗi (con × bậc) có neo
 *   riêng, và cỡ món quy theo MỰC THẬT của chính ảnh phụ kiện (`src/lib/accessoryFit.ts`).
 *   Tệp này chỉ còn: tầng vẽ, thứ tự chồng, và "đặt hộp vào neo".
 */

/**
 * Thứ tự chồng lớp (`z-index`) — ĐÂY LÀ THỨ QUYẾT ĐỊNH "ĐEO LÊN TRÔNG CÓ THẬT KHÔNG".
 *
 * ⚠️⚠️ NẾU CON VẬT NẰM TRÊN MỌI PHỤ KIỆN THÌ KÍNH BỊ CHÔN SAU ĐẦU.
 *   Bản đầu tiên của T04 cho con vật `z-[1]` và để mọi phụ kiện không có `z` — nghĩa là kính
 *   `face` (món DUY NHẤT phải nằm TRƯỚC mặt) bị con vật che mất. Trên màn hình điều đó đọc ra là
 *   "bé mặc kính rồi mà không thấy kính", và không cổng nào bắt được: jsdom không tính `z-index`.
 *
 * ⚠️⚠️ CÓ **HAI** NƠI SẮP LỚP, VÀ CHÚNG DÙNG **HAI CƠ CHẾ KHÁC NHAU** — ĐỪNG ĐỌC NỬA VỜI
 *    RỒI "SỬA THỨ TỰ DOM CHO ĐÚNG". Người kiểm chứng độc lập đã đo bằng `elementsFromPoint` trên
 *    trình duyệt thật và phát hiện chú thích cũ ở đây mô tả SAI cơ chế, nên ghi lại cho đúng:
 *
 *    (1) TRONG `PetAvatar` này (thẻ hồ sơ, đầu trang) — **`z-index` quyết định**:
 *        wrapper `behind` = `z-[1]` < con vật = `PET_Z` (`z-[2]`) < wrapper `front` = `z-[3]`.
 *        Món slot `back` để `z: auto` (xem `ACCESSORY_Z.back`), nhưng nó nằm TRONG wrapper `z-[1]`
 *        nên **luôn** ở dưới con vật — đúng như mong đợi, không cần quan tâm thứ tự chèn.
 *
 *    (2) TRONG "Góc phòng của bé" (`PetHousePage`) — **thứ tự chèn vào DOM + `z-index` của con vật**
 *        quyết định, KHÔNG phải `z-index` của món phụ kiện:
 *        `PetHousePage` đẩy món `back` vào lượt vẽ TRƯỚC con vật và món khác vào lượt SAU, qua
 *        `bottomPct` (`sortByBottom`). Nhưng vì con vật trong phòng nằm trong một `<span>` mang
 *        `z-[2]` (`PET_Z`), con vật **luôn thắng** `z: auto` của món `back` **bất kể thứ tự DOM**;
 *        chỉ những món `front` có `z-10` mới nổi lên trên. ⇒ Ai "sửa lại thứ tự DOM cho đúng" ở
 *        đó sẽ không thấy hậu quả gì, và sẽ tưởng mình làm sai. Muốn đổi thì phải đổi `z-index`.
 *
 *    ⇒ Nguồn sự thật của TẦNG lớp: hằng số dưới đây (thẻ hồ sơ) và `renderAccessoryNode`
 *      (trong phòng). Cả hai đã được đo bằng hit-test thật, không phải suy luận.
 */
const ACCESSORY_Z: Record<AccessorySlot, string> = {
  back: '',
  feet: 'z-[3]',
  head: 'z-[3]',
  neck: 'z-[3]',
  face: 'z-[4]',
};

/** Con vật nằm giữa: trên `back` (áo choàng/cánh ở sau lưng), dưới mọi thứ đeo trước người. */
const PET_Z = 'z-[2]';

export interface PetAvatarProps {
  /**
   * Con thú cưng bé đã chọn (`pet.petType`) — ĐÃ được server phân giải, **không bao giờ null**.
   *
   * ⚠️ Truyền ID, KHÔNG truyền emoji hay tên: hình và tên đều tra từ `shared/content/pets.json`
   *    qua `petEmojiFor`/`petNameVi`. Truyền emoji vào đây là mở đường cho màn hình vẽ một con
   *    trong khi nhãn đọc lên nói một con khác.
   */
  petType: PetType;
  /**
   * Giai đoạn tiến hoá do SERVER trả (`pet.evolutionStage`).
   *
   * ⚠️ Truyền ID, không truyền số từ: client **không** được tự đếm từ rồi tự suy giai đoạn — nếu
   *    làm vậy thì máy bé và server có thể nói hai giai đoạn khác nhau, và không có cách nào biết
   *    cái nào đúng. Server là trọng tài; component này chỉ tra id ra `{ name_vi, icon }`.
   */
  evolutionStage: EvolutionStage;
  /**
   * Các món ĐANG mặc / ĐANG bày — người gọi tự lọc `equipped === true`.
   *
   * Đồ ăn trong danh sách này bị BỎ QUA: `accessorySlotOf`/`decorationSlotOf` trả `null`. Đó là
   * chủ ý — đồ ăn bị tiêu khi cho ăn, nên "con vật đang đội một quả chuối" sẽ sớm thành một món
   * đồ không còn tồn tại.
   */
  items: readonly ShopItem[];
  className?: string;
  /**
   * Cỡ hộp `1em` của con vật, dạng độ dài CSS (ví dụ `'var(--room-pet-w)'`).
   *
   * ⭐ VÌ SAO CẦN: màn "Nhà thú cưng" vẽ con vật **TRONG PHÒNG**, và ở đó con vật phải lớn lên
   *   theo khung phòng (`34.5cqw`), không phải theo bậc tiến hoá (84/104/124px cố định của thẻ).
   *   Mọi neo phụ kiện (`petAnchors.ts`) là `%`-của-hộp-`1em`, nên chỉ cần đặt `font-size` là
   *   **con vật VÀ toàn bộ phụ kiện cùng phóng** — không cần bảng tra nào theo bối cảnh.
   *
   * Bỏ trống ⇒ giữ nguyên hành vi cũ (cỡ theo bậc, khung 200×200) — thẻ ở đầu trang không đổi.
   */
  sizeEm?: string;
  /**
   * Ghi đè lớp của KHUNG NGOÀI. Mặc định `size-[200px]` (khung thẻ).
   *
   * ⚠️ Khi truyền `sizeEm`, hãy truyền luôn khung theo bối cảnh (ví dụ `'h-full w-full'`), nếu
   *   không khung 200px cố định sẽ cắt/đè lên con vật đã phóng to.
   */
  frameClassName?: string;
  /**
   * Bối cảnh TRẦN: chỉ **con vật + phụ kiện**, không thẻ.
   *
   * ⭐ VÌ SAO CẦN: màn "Nhà thú cưng" đã có phòng riêng (tường/baseboard/sàn + khung 4:3), nên nếu
   *   nhét nguyên cái THẺ vào trong phòng thì bé thấy **một cái thẻ lồng trong một cái phòng**:
   *   dải trời + dải cỏ + viền bo + dòng chữ "🐵 Trưởng thành" nằm chồng lên sàn gỗ. Đó không phải
   *   "con vật đang chơi trong nhà" — đó là hai bối cảnh chồng lên nhau.
   *
   * `bare` bỏ: dải trời, dải cỏ, viền/bo/nền, chú thích giai đoạn, và `role="img"` + nhãn.
   *
   * ⚠️ VÌ SAO BỎ CẢ NHÃN ĐỌC LÊN: cùng một con vật đã được đọc ở thẻ đầu trang bằng ĐÚNG nhãn đó
   *    (`pet.sceneWearing` / `pet.sceneBare`). Để nguyên thì trình đọc màn hình đọc hai lần cùng
   *    một thông tin — và trong phòng, con vật chỉ là hình ảnh trang trí, bé không bấm vào được.
   *    Bỏ nhãn ở đây KHÔNG mất thông tin: thông tin vẫn còn nguyên ở thẻ đầu trang.
   */
  bare?: boolean;
  /**
   * ĐỌC NHÃN LÊN (`role="img"` + `aria-label`) dù đang ở bối cảnh `bare`.
   *
   * ⭐ VÌ SAO CẦN (2026-10-14): lý do bỏ nhãn ở `bare` là "thẻ đầu trang đã đọc rồi". Nhưng màn
   *   "Nhà thú cưng" nay chỉ còn **MỘT** khung vẽ con vật — chính khung TRONG PHÒNG (chủ dự án:
   *   *"bỏ khung đầu, chỉ giữ lại khung phòng của thú cưng"*). Khi khối phòng là chỗ DUY NHẤT vẽ
   *   con vật thì bỏ nhãn ở đó = bé khiếm thị mất hẳn câu "Momo đang dùng: Mũ, Khăn quàng".
   *   Người gọi truyền `announce` để khối đó tự mang nhãn — thông tin đi theo **chỗ vẽ**, không
   *   đi theo một khung đã bị xoá.
   */
  announce?: boolean;
  /**
   * Độ lệch bé KÉO cho từng món ĐANG MẶC, theo `itemId` — `{ dx, dy }` tính bằng **% hộp `1em`**
   * của con vật (xem `AccessoryOffset` trong `accessoryFit.ts`).
   *
   * ⭐ VÌ SAO LÀ PROP, KHÔNG ĐỌC STORE: `PetAvatar` là component CÂM (xem ghi chú đầu tệp). Nó
   *   cũng được dùng ở màn chọn con — nơi không có khái niệm "kéo mũ". Người gọi nào có dữ liệu
   *   thì truyền vào; bỏ trống ⇒ mọi món ở đúng công thức neo như trước.
   */
  accessoryOffsets?: Readonly<Record<string, AccessoryOffset>>;
}

export function PetAvatar({
  petType,
  evolutionStage,
  items,
  className,
  sizeEm,
  frameClassName,
  bare = false,
  announce = false,
  accessoryOffsets,
}: PetAvatarProps) {
  const { t } = useTranslation();

  /** Tên con vật — tra từ DỮ LIỆU, không nhận qua prop (xem ghi chú đầu tệp). */
  const petName = petNameVi(petType);

  /** Hình con vật theo (con × bậc) — tra từ DỮ LIỆU, không từ bảng tra trong tệp này. */
  const petIcon = petEmojiFor(petType, evolutionStage);

  /** Tên giai đoạn, tra từ DỮ LIỆU (`xp-levels.json`). */
  const stage = stageDefinition(evolutionStage);

  /**
   * Chia phụ kiện theo vị trí. Dùng `Map` để một vị trí có thể có NHIỀU món (bé mặc cả nơ và
   * vương miện — server không cấm, và CẤM là trái luật "không lấy gì của bé": tự bỏ chiếc nơ ra
   * khi bé đội vương miện chính là lấy đi một thứ bé đã mua).
   */
  const worn = useMemo(() => {
    const map = new Map<AccessorySlot, ShopItem[]>();
    for (const item of items) {
      const slot = accessorySlotOf(item);
      if (slot === null) continue;
      const list = map.get(slot);
      if (list === undefined) {
        map.set(slot, [item]);
      } else {
        list.push(item);
      }
    }
    return map;
  }, [items]);

  /**
   * Nhãn cho trình đọc màn hình.
   *
   * ⚠️ Toàn bộ ảnh/emoji bên trong đều `aria-hidden`, nên nếu không có nhãn này thì bé khiếm thị
   *    nghe được ĐÚNG MỘT chữ cái rời rạc hoặc không gì cả — trong khi cả màn hình vừa đổi vì bé
   *    vừa mua một món đồ mới. Sự thay đổi ấy phải nghe được.
   *
   * Thứ tự đọc theo `ACCESSORY_SLOTS` (không theo thứ tự túi đồ) để câu văn ổn định giữa các
   * lần mua.
   *
   * ⚠️ ĐỒ TRANG TRÍ KHÔNG CÒN ĐƯỢC ĐỌC Ở ĐÂY — và đó là sửa một lời nói dối. Trang trí nay nằm
   *    trong khối "Góc phòng của bé" (`PetHousePage`), nơi bé KÉO THẢ chúng; `PetAvatar` chỉ nhận
   *    phụ kiện (người gọi lọc `decorationSlotOf(item) === null`). Bản trước vẫn có nhánh nhãn
   *    "Quanh nhà có …" cho những món **không hề được vẽ** trong khối này — nhãn nói có mà mắt
   *    không thấy gì. Xem `scenery` đã bị xoá ở dưới.
   */
  const wearingNames = ACCESSORY_SLOTS.flatMap((slot) =>
    (worn.get(slot) ?? []).map((item) => item.name_vi),
  );

  const labelParts: string[] = [];
  if (wearingNames.length > 0) {
    labelParts.push(t('pet.sceneWearing', { pet: petName, items: wearingNames.join(', ') }));
  }
  if (labelParts.length === 0) {
    labelParts.push(t('pet.sceneBare', { pet: petName }));
  }

  /** Neo của ĐÚNG con × bậc đang hiện. Thiếu dữ liệu ⇒ `DEFAULT_PET_ANCHOR` (không ném lỗi). */
  const anchor = petAnchorFor(petType, evolutionStage);

  /**
   * Hai bàn chân RIÊNG của đúng con × bậc đang hiện — cần cho món phải vẽ hai lần (giày).
   *
   * ⚠️ `anchor.feet` là neo của **cả hai bàn chân gộp**, không dùng được để đặt hai chiếc giày ở
   *    hai chỗ. `feetSplitFor` trả tâm + bề rộng TỪNG bàn chân (đo cho 18/18 con), và tự lùi về
   *    tỉ lệ trung bình khi thiếu dữ liệu — không bao giờ ném lỗi.
   */
  const feet = feetSplitFor(petType, evolutionStage);

  const isSuper = evolutionStage === 'super';

  /*
    HỘP `1em × 1em` — CHÍNH LÀ Ô CHỮ CỦA CON VẬT, và là HỆ TOẠ ĐỘ DUY NHẤT của phụ kiện.
    `1em` = `font-size` của khung cha (84 / 104 / 124px theo bậc, hoặc `--room-pet-w` khi ở trong
    phòng), nên hộp này lớn lên cùng con vật; neo `%`-của-hộp vì thế cùng lớn lên. Số neo là
    **của riêng từng ảnh** — xem `petAnchorFor` trong `src/lib/petAnchors.ts`.

    ⚠️ TÁCH RA BIẾN DÙNG CHUNG CHO CẢ HAI BỐI CẢNH (`bare` và thẻ): đây là phần *duy nhất* quyết
       định con vật trông ra sao. Chép lại nó cho bối cảnh thứ hai là mở đường cho hai bản vẽ
       lệch nhau — đúng loại lỗi đã xảy ra với bảng neo dùng chung trước đây.

    ⚠️ Không đặt `overflow: hidden` ở đây: mũ phải nhô lên trên đỉnh đầu và ba lô phải thò
       ra ngoài sườn (cả hai đều có toạ độ ÂM).
  */
  const petBox = (
    <div className="relative flex size-[1em] items-center justify-center">
      {/*
        Bóng ellipse dưới chân — NEO thị giác, cho con vật một mặt đất để đứng lên.
        Cỡ tính bằng `em` (không phải px) để bóng lớn lên cùng con vật: một cái bóng 90px cố
        định dưới một con `super` 124px trông như một vết bẩn rời rạc.
      */}
      <span
        aria-hidden="true"
        className="absolute bottom-[0%] left-1/2 z-0 h-[0.10em] w-[1.05em] -translate-x-1/2 rounded-pill bg-pet-shadow"
      />

      {/*
        Wrapper duy nhất tạo stacking context cho phụ kiện sau lưng. Slot `back` bên trong
        không có z-index riêng, để z-index từng món chỉ quyết định thứ tự trong cùng slot.
      */}
      <div
        aria-hidden="true"
        data-accessory-layer="behind"
        className="pointer-events-none absolute inset-0 z-[1]"
      >
        <AccessoryLayers
              slots={ACCESSORY_SLOTS}
              worn={worn}
              only="behind"
              anchor={anchor}
              feet={feet}
              offsets={accessoryOffsets}
            />
      </div>

      {/*
        Con vật. Cỡ = `font-size` của khung cha, ảnh thừa hưởng qua `1em`.
        ⚠️ `relative` cần thiết: nó giữ con vật trong ngữ cảnh xếp lớp của hộp để `z-[2]` có
           hiệu lực (trên `back`, dưới `feet/head/neck/face`).
      */}
      <span aria-hidden="true" className={cn('relative leading-none', PET_Z)}>
        <PetArtwork petType={petType} evolutionStage={evolutionStage} fallback={petIcon} />
      </span>

      {/* Phụ kiện ĐEO TRƯỚC NGƯỜI (giày, mũ, khăn, kính). */}
      <div
        aria-hidden="true"
        data-accessory-layer="front"
        className="pointer-events-none absolute inset-0 z-[3]"
      >
        <AccessoryLayers
              slots={ACCESSORY_SLOTS}
              worn={worn}
              only="inFront"
              anchor={anchor}
              feet={feet}
              offsets={accessoryOffsets}
            />
      </div>

      {/* Dấu "Siêu cấp": tia sáng ở góc trên phải. Cỡ bằng `em` để lớn lên cùng con vật.
          `animate-pulse` đã bị tắt sẵn dưới `prefers-reduced-motion` (xem `tokens.css`). */}
      {isSuper && (
        <span
          aria-hidden="true"
          className="absolute right-[2%] top-[-4%] animate-pulse text-[0.34em] leading-none"
        >
          ✨
        </span>
      )}
    </div>
  );

  /*
    KHUNG chứa hộp con vật. Cỡ do NGƯỜI GỌI quyết (`sizeEm` + `frameClassName`), mặc định là khung
    thẻ 200×200 với cỡ chữ theo bậc tiến hoá.

    ⚠️⚠️ `flex items-center justify-center` LÀ BẮT BUỘC — KHÔNG ĐƯỢC GỠ.
      Con vật là một `<span>` INLINE. Trong một `<div>` thường nó trôi về GÓC TRÊN-TRÁI —
      đo trên trình duyệt thật (Playwright/Chromium): tâm con vật ở **28,8% / 31,3%** thay vì
      50% / 50%. Hệ quả đo được: mũ lơ lửng cạnh tai, kính nằm ngang MÁ chứ không trên mắt,
      khăn rơi dưới cằm, giày cách xa chân — đúng lời chủ dự án: *"các icon đeo vô con pet
      cũng khá là thô, lung tung"*. Tiêm `display:flex; align-items:center; justify-content:
      center` vào ô (chỉ sửa DOM sống) đưa tâm con vật về **50% / 50%** và mọi món rơi đúng
      người ngay lập tức.
  */
  const petFrame = (
    <div
      className={cn(
        'relative mx-auto flex shrink-0 items-center justify-center',
        frameClassName ?? 'size-[200px]',
        // ⚠️ Khi người gọi tự đặt cỡ (`sizeEm`) thì KHÔNG áp cỡ theo bậc nữa — hai nguồn
        //    `font-size` cùng lúc là hai nguồn sự thật, và cái sau sẽ thắng một cách mơ hồ.
        sizeEm === undefined && STAGE_TEXT_SIZE[evolutionStage],
      )}
      style={sizeEm === undefined ? undefined : { fontSize: sizeEm }}
    >
      {petBox}
    </div>
  );

  /*
    BỐI CẢNH TRẦN — xem ghi chú `bare` ở `PetAvatarProps`. Chỉ con vật + phụ kiện.
  */
  if (bare) {
    /*
      ⚠️ `aria-hidden` hay `role="img"` + nhãn là quyết định của NGƯỜI GỌI (`announce`), không
         phải của khối này: mặc định khối trần là TRANG TRÍ (đã có thẻ khác đọc thông tin), nhưng
         khi nó là chỗ vẽ DUY NHẤT thì nhãn phải ở lại (xem `announce`).
    */
    return (
      <div
        className={cn('flex flex-col', className)}
        {...(announce
          ? { role: 'img', 'aria-label': labelParts.join('. ') }
          : { 'aria-hidden': true })}
      >
        {petFrame}
      </div>
    );
  }

  return (
    <div className={cn('flex flex-col gap-1', className)}>
      {/*
        Khối "sân nhà" mang `role="img"` + nhãn đọc lên. ⚠️ Mọi thứ BÊN TRONG nó đều bị coi là
        trang trí (con của `role="img"` không được đọc), nên chú thích giai đoạn phải nằm NGOÀI
        khối này — xem thẻ `<p>` ngay dưới.
      */}
      <div
        role="img"
        aria-label={labelParts.join('. ')}
        className={cn(
          // `bg-surface-raised` là nền của DẢI GIỮA (khoảng trời–đất mà con vật đứng trong đó).
          // Thiếu nó thì dải giữa trong suốt, và ba dải trông như hai mẩu giấy dán lên nền trang.
          'relative flex flex-col overflow-hidden rounded-card border-2 border-line bg-surface-raised',
          // Bậc "Siêu cấp" có quầng sáng quanh khung — dấu hiệu thị giác cho đỉnh tiến hoá, đọc
          // được cả khi bé chưa nhận ra emoji đã đổi.
          isSuper && 'shadow-super',
        )}
      >
        {/*
          DẢI 1 — TRỜI. Đường chân trời để mắt đọc được "mũ nằm ở trên".

          ⚠️ Đây chỉ còn là DẢI MÀU, không còn là hàng chứa đồ trang trí. Bản trước nó là
             `SceneryRow` — một `<ul>` LUÔN render 0 phần tử ở production, vì `PetHousePage` lọc
             `decorationSlotOf(item) !== null` ra khỏi `items` (trang trí nay nằm trong khối "Góc
             phòng của bé", nơi bé kéo thả). Cơ chế đó không vẽ được gì mà vẫn giữ cửa cho một
             đường vẽ thứ hai của cùng một dữ liệu; đã xoá hẳn. Dải màu GIỮ LẠI vì nó là đường
             chân trời — thứ đã được chốt ở "QUYẾT ĐỊNH C3" và không liên quan tới phụ kiện.
        */}
        <div aria-hidden="true" className="bg-pet-sky px-3 pt-2 pb-1" />

        {petFrame}

        {/* DẢI 2 — ĐẤT / CỎ. Cùng lý do như DẢI 1: chỉ còn là dải màu, không còn hàng trang trí. */}
        <div aria-hidden="true" className="bg-pet-ground px-3 pt-1 pb-2" />
      </div>

      {/*
        Chú thích giai đoạn — chữ THẬT, nằm NGOÀI khối `role="img"` (con của nó bị coi là trang trí
        nên sẽ không được đọc). Bé thấy chữ này, và trình đọc màn hình cũng đọc nó.

        ⚠️ Tên giai đoạn lấy từ `xp-levels.json` (`🐣 Nhóc con`, `🐵 Trưởng thành`, `✨ Siêu cấp`),
        **KHÔNG** từ i18n — cùng lý do như tên tiền tệ ở màn Cửa hàng: khai lại là tạo nguồn sự
        thật thứ hai, và nó sẽ lệch nhau đúng vào ngày ai đó sửa JSON.
      */}
      <p className="text-center text-kid-xs font-bold text-ink-soft">{stage.name_vi}</p>
    </div>
  );
}

/**
 * Vẽ các lớp phụ kiện theo ĐÚNG một tầng chồng (`behind` = sau lưng, `inFront` = trước người).
 *
 * ⚠️ VÌ SAO TÁCH THÀNH HAI LƯỢT GỌI QUANH CON VẬT, thay vì một vòng lặp duy nhất:
 *    Thứ tự chồng lớp ở đây KHÔNG đi theo thứ tự trong `ACCESSORY_SLOTS` — con vật chen vào giữa.
 *    Một vòng lặp duy nhất sẽ phải biết "chèn con vật vào đâu", tức là logic vẽ bị trộn với logic
 *    dữ liệu. Hai lượt gọi nói thẳng ra thứ tự bằng chính cấu trúc DOM.
 *
 * ⚠️ MỘT `<span>` CHO MỖI VỊ TRÍ (không phải mỗi món) — giữ nguyên cơ chế cũ: slot wrapper là
 *    `absolute inset-0` phủ đúng hộp `1em`, và nó KHÔNG BAO GIỜ bỏ món nào của bé.
 *
 * ⚠️ NHƯNG MỖI MÓN có HỘP RIÊNG (`accessoryBox`): ba món của slot `head` (mũ / vương miện / nơ)
 *    có cỡ mực và cao độ khác nhau, và cả 10 ảnh phụ kiện có độ "đầy" khác nhau (72%–98%). Dùng
 *    chung một hộp `1,65em × 1,35em` như bản cũ là nguồn của "món to món nhỏ tuỳ ảnh".
 *    Cấu trúc DOM:
 *      slot wrapper (`absolute inset-0`, z theo slot)
 *        └ món (`data-accessory-id`, `absolute inset-0`, lệch nhẹ ổn định khi cùng slot)
 *            └ HỘP (`left/top/width/height` tính từ neo + tỷ lệ mực, canh tâm bằng translate)
 *                └ `ShopArtwork`
 *
 * ⚠️ Thứ tự lớp trong `back` KHÔNG được đặt z-index lên slot wrapper: nó sẽ nhốt z-index của các
 *    món con lại và phá hợp đồng "slot back nằm sau con vật". Xem `ACCESSORY_Z`.
 */
function PetArtwork({
  petType,
  evolutionStage,
  fallback,
}: {
  petType: PetType;
  evolutionStage: EvolutionStage;
  fallback: string;
}) {
  const source = petArtworkUrl(petType, evolutionStage);
  if (!source) return <>{fallback}</>;

  return (
    <>
      <img
        src={source}
        alt=""
        draggable={false}
        className="pointer-events-none h-[1em] w-[1em] select-none object-contain"
        onError={(event) => {
          event.currentTarget.hidden = true;
          event.currentTarget.nextElementSibling?.removeAttribute('hidden');
        }}
      />
      <span hidden>{fallback}</span>
    </>
  );
}

function AccessoryLayers({
  slots,
  worn,
  only,
  anchor,
  feet,
  offsets,
}: {
  slots: readonly AccessorySlot[];
  worn: Map<AccessorySlot, ShopItem[]>;
  only: 'behind' | 'inFront';
  /** Neo của con × bậc đang hiện (`petAnchorFor`) — nguồn toạ độ duy nhất. */
  anchor: PetAnchor;
  /** Tâm + bề rộng TỪNG bàn chân (`feetSplitFor`) — cần cho món vẽ hai lần (giày). */
  feet: PetFeetAnchor;
  /** Độ lệch bé kéo, theo `itemId` (% hộp con vật). `undefined` ⇒ mọi món ở vị trí gốc. */
  offsets: Readonly<Record<string, AccessoryOffset>> | undefined;
}) {
  return (
    <>
      {slots.map((slot) => {
        /*
          ⚠️⚠️ `slot === 'back'` vẫn quyết định món nằm SAU lưng (ba lô, áo choàng, cánh) — nhưng
          đó KHÔNG còn là toàn bộ câu chuyện. Món ĐANG MẶC mà QUẤN quanh cơ thể (khăn quàng, giày)
          phải được vẽ HAI LẦN ở HAI LƯỢT: phần trên ở lượt SAU, phần dưới ở lượt TRƯỚC — nhờ vậy
          cơ thể mới CHE được một phần món đồ, và mắt mới đọc ra "đang mặc" thay vì "để gần".
          Xem `ACCESSORY_WRAP` trong `accessoryFit.ts`.

          Vì vậy KHÔNG được `return null` sớm theo `slot`: một món thuộc slot `neck` vẫn phải xuất
          hiện ở LƯỢT SAU (nửa trên). Điều kiện bỏ qua phải dựa trên TỪNG BẢN VẼ, ở dưới.
        */
        const list = worn.get(slot);
        if (list === undefined || list.length === 0) return null;

        return (
          <span
            key={slot}
            aria-hidden="true"
            data-accessory-slot={slot}
            className={cn('absolute inset-0 leading-none', ACCESSORY_Z[slot])}
          >
            {list.map((item, index) => {
              const offset = index - (list.length - 1) / 2;
              const zIndex = list.length - index;
              /**
               * ⚠️ Món chưa khai tỷ lệ mực ⇒ `accessoryLayoutFor` tự lùi về `DEFAULT_ACCESSORY_INK`
               *    (mực đầy hộp) + kiểu đặt suy từ `slot`. Món vẫn HIỆN, chỉ kém chuẩn — không được
               *    biến mất khỏi người bé.
               *
               * ⚠️⚠️ MỘT NGUỒN TOẠ ĐỘ: `accessoryLayoutFor` là hàm DUY NHẤT quyết định hộp + độ
               *    lệch kéo tay. `wornAccessoryHitCenter` (vùng chạm trong phòng) gọi đúng hàm này
               *    — tự ghép lại ở đó là mở đường cho "bấm vào mũ lại tháo mất món vừa kéo".
               *
               * ⚠️ Hàm trả NHIỀU hộp cho món như GIÀY (`ACCESSORY_MIRRORED`): ảnh giày nay là MỘT
               *    CHIẾC nên phải vẽ hai lần, lần thứ hai lật gương.
               */
              const layout = accessoryLayoutFor(
                item.id,
                slot,
                anchor,
                feet,
                offsets?.[item.id] ?? NO_ACCESSORY_OFFSET,
              );
              const kind = layout.kind;
              const placements = layout.placements;
              /*
                ⚠️⚠️ TÍNH BẢN VẼ CỦA LƯỢT NÀY TRƯỚC KHI RENDER — và bỏ qua CẢ KHỐI nếu lượt này không
                có gì để vẽ. Nếu để khối ngoài (`data-accessory-id`) luôn hiện ở cả hai lượt thì:
                  • DOM có HAI phần tử cùng `data-accessory-id` cho một món ⇒ mọi truy vấn kiểu
                    `querySelector('[data-accessory-id]')` chỉ thấy phần tử RỖNG ở lượt sau;
                  • test đếm số món và các công cụ đo đều đọc sai.
              */
              const layerParts = placements
                .map((placement, partIndex) => ({ placement, partIndex }))
                .filter(({ placement }) =>
                  only === 'behind'
                    ? slot === 'back' || placement.wrapCutPct !== null
                    : slot !== 'back' || placement.wrapCutPct !== null,
                );
              if (layerParts.length === 0) return null;

              return (
                <span
                  key={item.id}
                  aria-hidden="true"
                  data-accessory-id={item.id}
                  data-accessory-kind={kind}
                  /*
                   * ⚠️ Neo CSS đặt bằng `style` (số đo được, khác nhau từng con × bậc), nhưng
                   *    KHÔNG được đặt `transform` ở đây: hộp con canh tâm bằng lớp
                   *    `-translate-x-1/2 -translate-y-1/2`, và một `transform` inline sẽ ĐÈ SẠCH nó
                   *    (đúng cái bẫy đã trả giá ở T056). Lệch nhẹ khi cùng slot nằm ở lớp NGOÀI
                   *    CÙNG của món — nơi `transform` đứng một mình.
                   */
                  className="absolute inset-0 leading-none"
                  style={{
                    transform: `translateX(${offset * 0.16}em) translateY(${Math.abs(offset) * 0.08}em)`,
                    zIndex,
                  }}
                >
                  {layerParts.map(({ placement, partIndex }) => {
                    /*
                      ⚠️⚠️ BẢN VẼ CỦA LƯỢT NÀY — XEM `ACCESSORY_WRAP` trong `accessoryFit.ts`.
                      `wrapCutPct` khác `null` = món QUẤN quanh cơ thể, phải cắt làm hai:
                        • LƯỢT SAU (`only='behind'`) → nửa TRÊN (`inset(0 0 (100−cut)% 0)`)
                        • LƯỢT TRƯỚC (`only='inFront'`) → nửa DƯỚI (`inset(cut% 0 0 0)`)
                      Món không quấn ⇒ vẽ nguyên ở đúng lượt theo `slot` như cũ.
                    */
                    const wrap = placement.wrapCutPct;
                    const wrapped = wrap !== null;
                    const clipPath = wrapped
                      ? only === 'behind'
                        ? `inset(0 0 ${100 - wrap}% 0)`
                        : `inset(${wrap}% 0 0 0)`
                      : undefined;
                    return (
                    <span
                      // Thứ tự + lượt vẽ là DANH TÍNH DUY NHẤT của các bản vẽ.
                      key={`${partIndex}-${only}`}
                      aria-hidden="true"
                      data-accessory-part={wrapped ? (only === 'behind' ? 'upper' : 'lower') : 'whole'}
                      className="absolute block -translate-x-1/2 -translate-y-1/2"
                      style={{
                        left: `${placement.box.cx * 100}%`,
                        top: `${placement.box.cy * 100}%`,
                        width: `${placement.box.side * 100}%`,
                        clipPath,
                        /*
                          ⚠️⚠️ CHIỀU CAO = `side × squashY`, KHÔNG phải `side`. Hộp không còn luôn
                          vuông khi một kiểu đặt cần ÉP DẸT theo chiều dọc (`ACCESSORY_SQUASH`;
                          hiện mọi kiểu = 1 vì art đã đúng góc, nhưng cơ chế được giữ để lần sau
                          gặp ảnh sai góc thì chỉ cần điền một số). `ShopArtwork` vẽ
                          `h-full w-full object-contain` nên ảnh vuông tự bị ép theo hộp.
                        */
                        height: `${placement.box.side * placement.box.squashY * 100}%`,
                        /*
                          ⚠️⚠️ KHÔNG ĐƯỢC đặt `transform` Ở LỚP NÀY. Lớp này canh tâm bằng
                          `-translate-x-1/2 -translate-y-1/2`, và một `transform` inline sẽ ĐÈ SẠCH
                          phép canh tâm đó (Tailwind biên dịch lớp kia thành chính thuộc tính
                          `transform`). Đây là bẫy đã trả giá HAI LẦN — lần thứ hai ngay trong bản
                          vá giày: viết `transform: 'scaleX(-1)'` ở đây làm chiếc giày PHẢI mất canh
                          tâm, lệch xuống 14,7% hộp và lệch sang phải 37% hộp so với chiếc trái.
                          Phép lật nằm ở LỚP CON bên dưới — xem ghi chú ở đó.
                        */
                      }}
                    >
                      {/*
                        ⚠️ LỚP LẬT GƯƠNG — một `<span>` riêng, `transform` đứng MỘT MÌNH (không
                        lớp nào khác trên nó dùng `transform`). Nhờ vậy thứ tự `translate`/`scaleX`
                        không còn là câu hỏi, và canh tâm ở lớp cha vẫn nguyên vẹn.
                        `inline-block` để phần tử nhận đúng kích thước của lớp cha (`h-full w-full`).
                      */}
                      <span
                        aria-hidden="true"
                        className="block h-full w-full"
                        style={placement.mirror ? { transform: 'scaleX(-1)' } : undefined}
                      >
                        <ShopArtwork item={item} className="h-full w-full object-contain" />
                      </span>
                    </span>
                    );
                  })}
                </span>
              );
            })}
          </span>
        );
      })}
    </>
  );
}
